// src/app/shared/shared-pipes.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanModulePipe } from './can-module.pipe';
import { AllowedActionsForModulePipe } from './allowed-actions-for-module.pipe';
import { AccountingNumberPipe } from './accounting-number.component';
import { HasMenuAccessPipe } from './has-menu-access.pipe';

@NgModule({
 declarations: [CanModulePipe, AllowedActionsForModulePipe, AccountingNumberPipe],
  imports: [CommonModule, HasMenuAccessPipe],
  exports: [CanModulePipe, AllowedActionsForModulePipe, AccountingNumberPipe, HasMenuAccessPipe]
})
export class SharedPipesModule {}
